export default __webpack_public_path__ + "static/media/apa.a09b1d4f.png";